// extracted by mini-css-extract-plugin
module.exports = {"reviewInCart":"az_Kdb"};